export default __webpack_public_path__ + "static/media/partner_03.6d2e343b.png";